import React from 'react';

import { Text } from 'mintel-react-ui';

import styles from './TranslationsNav.scss';
import { TranslationResult } from '../../types';

type TranslationsNavProps = {
  translations: TranslationResult[];
};

const LANGUAGE_NAMES: Record<string, string> = {
  en: 'English',
  fr: 'Français',
  de: 'Deutsch',
  es: 'Español',
  it: 'Italiano',
  pt: 'Português',
  ja: '日本語',
  zh: 'Chinese',
  ko: '한국어',
  th: 'ไทย',
  vi: 'Tiếng Việt',
  id: 'Bahasa Indonesia',
};

const TranslationsNav: React.FC<TranslationsNavProps> = ({ translations }) => {
  if (!translations?.length) return null;

  const languageMap = translations.reduce((languageMap, translation) => {
    languageMap[translation.language] = translation;
    return languageMap;
  }, {} as Record<string, TranslationResult>);
  const languageOptions = Object.entries(LANGUAGE_NAMES)
    .filter(([code]) => code in languageMap)
    .map(([code]) => ({
      label: LANGUAGE_NAMES[code],
      value: languageMap[code].absolute_url,
      isCurrent: languageMap[code].is_current,
    }));

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        <Text.Heading5 darkBg>Language Version</Text.Heading5>
      </div>
      {languageOptions.map((option) =>
        option.isCurrent ? (
          <div key={option.value} className={styles['non-link-item']}>
            {option.label}
          </div>
        ) : (
          <a
            key={option.value}
            className={styles['link-item']}
            href={option.value}
            rel="noreferrer"
            target="_blank"
          >
            {option.label}
          </a>
        ),
      )}
    </div>
  );
};

export default TranslationsNav;
